import { render, staticRenderFns } from "./email-post-card.vue?vue&type=template&id=9ba39178&"
import script from "./email-post-card.vue?vue&type=script&lang=js&"
export * from "./email-post-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports